'use strict';/* global define */define('modules/users/services/watchlist/index',['require','exports','module'],function(require,exports,module){'use strict';function factory($resource,API_ENDPOINT){// jshint validthis:true
// jshint latedef:false
var watchlistBase=API_ENDPOINT+'watchlist';var watchlistUrl=watchlistBase+'/:id';var Watchlist=$resource(watchlistUrl,{id:'@id'},{get:{isArray:true}});return{getUsers:getUsers,addUser:addUser,removeUser:removeUser};// ---
/**
     * Get the users in the watchlist
     *
     * @param {Object|Undefined} params - Optional request params
     *
     * @returns {Obejct}                - Return $resource object
     */function getUsers(params){var list=Watchlist.get(params);list.$type='watchlist';return list;}/**
     * Perform POST request and add a user to the watchlist
     *
     * @param {Object|undefined} params - Optional request params
     */function addUser(params){return Watchlist.save(params);}/**
     * Perform DELETE request and delete a user from the list
     *
     * @param {Object|undefined} params - Optional request params
     */function removeUser(params){return Watchlist.delete(params);}}module.exports=factory;});
